import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=935850c2&scoped=true&"
var script = {}
import style0 from "./Users.vue?vue&type=style&index=0&id=935850c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935850c2",
  null
  
)

export default component.exports